export const cn = {
  title: '第七史诗团战汇报工具',
  darkMode: '深色模式',
  tower: '防守方名字(可选)...',
  t1: 'P1',
  t2: 'P2',
  report: '生成报告',
  firstHero: '你的一速英雄',
  speed: '速度',
  speedimprint: '速度阵',
  hp: '生命',
  cr: '% 速攻值',
  outspeed: '被对方超车?',
  outspeedDesc: '对面比我快?',
  setCounter: '反击套',
  setImmunity: '免疫套',
  extraInfos: '备注...',
  heroesSaved: '你输入的英雄以及速度会保存在本地',
  copyText: '复制到剪贴板',
  copyTextSL: '复制到剪贴板(单行)',
  reset: '数据重置',
  copyToast: '已复制到剪贴板!',
  resetToast: '数据已重置!',
  enemiesFirstHero: '对方一速',
  enemiesSecondHero: '对方二速',
  enemiesThirdHero: '对方尾速',
  enemiesFirstArtifact: '神器',
  enemiesSecondArtifact: '神器',
  enemiesThirdArtifact: '神器',
  formatHpK: '万',
  crBonus: '% 速攻值变化(退条)',
  crBonusDesc: '例子 : 如果你一速英雄被巴萨尔退条，此处填写30',
  crPush: '% 速攻值变化(拉条)',
  crPushDesc: '例子 : 如果你一速英雄被萝季超车拉条，此处填写25',
  crPushAlly: '% 速攻值变化(队友拉条)',
  crPushAllyDesc: '例子 : 如果你的大将法济斯被敌人攻击，此处填写15',
};
